module.exports = __webpack_public_path__ + "static/media/warning-24px.514f8e97.svg";